module.exports = __webpack_public_path__ + "img/1F1EC-1F1F3.3ce850c9.svg";